
var stache = require('can/view/stache/stache');
module.exports = stache("<custom-merchandise {merchandise}=\"products\" {cta-link}=\"productsCtaLink\" {cta-inside-slide}=\"true\" {swiper-options}=\"swiperOptions\" {show-nav-mobile-buttons}=\"true\" />\r\n");